export default __webpack_public_path__ + "static/media/champion_black.7801b11e.svg";